import React, { useState } from 'react';
import { View } from 'react-native';
import {
  add_contact_name_str,
  add_contact_name_note,
  Add_recipient_validation_step,
  Allow_customer_save_recipient,
  arrow,
  enable_recipient_validation,
  magnifying_lens,
  recipientVerifyStr,
  save_to_list,
  Validation_icon,
} from '../../../utils/DictionaryManagementUtils';
import SwitcherPanel from '../Buttons/SwitcherPanel';
import OpenBoxPanel from '../Buttons/OpenBoxPanel';
import { LocStr } from '../../../utils/Utils';

//= ========================================================================

const ManualRecipientConfigurations = ({
  globJSON,
  language,
  subCategoryId,
  manualName,
  onConfigChanged,
}) => {
  const { recipient } = globJSON.configurations.services[subCategoryId];
  const manual_recipient = recipient.manual_recipients[manualName];
  const [isBoxOpen, setBoxOpen] = useState(false);

  const onRecipientConfigurationChanged = (key, value) => {
    manual_recipient[key] = value;
    onConfigChanged();
  };

  return (
    <View style={{ zIndex: 2 }}>
      <View style={{ marginBottom: 14, zIndex: 2 }}>
        <SwitcherPanel
          text={Add_recipient_validation_step}
          value={manual_recipient.enable_recipient_validation}
          onValueChanged={(value) => {
            onRecipientConfigurationChanged(enable_recipient_validation, value);
          }}
        />
        {manual_recipient.enable_recipient_validation
          && (
            <OpenBoxPanel
              language={language}
              isBoxOpen={isBoxOpen}
              text={LocStr(Validation_icon, language)}
              chosenValue={globJSON.configurations.general.is_arrow_icon ? arrow : magnifying_lens}
              valuesMap={recipientVerifyStr}
              onPress={() => {
                setBoxOpen(!isBoxOpen);
              }}
              onValueChanged={(valueId) => {
                globJSON.configurations.general.is_arrow_icon = valueId === arrow;
                onConfigChanged();
              }}
            />
          )}
      </View>
      <View style={{ marginBottom: 14 }}>
        <SwitcherPanel
          text={Allow_customer_save_recipient}
          value={manual_recipient.save_to_list}
          onValueChanged={(value) => {
            onRecipientConfigurationChanged(save_to_list, value);
          }}
        />
        {manual_recipient.save_to_list
          && (
            <SwitcherPanel
              key={add_contact_name_str}
              text={add_contact_name_note}
              value={manual_recipient.add_contact_name}
              onValueChanged={(value) => {
                onRecipientConfigurationChanged('add_contact_name', value);
              }}
              internalFlag
            />
          )}
      </View>
    </View>
  );
};
export default ManualRecipientConfigurations;
